<script>
import { getFreeUserMeetingMinutes } from '@/utils/meeting';

export default {
  name: 'basic-related-tip',
  methods: { getFreeUserMeetingMinutes },
};
</script>

<template>
  <div class="opc-zsched__basic-related-tip">
    {{ $t('billing.scheduler.basic_include_tip', [getFreeUserMeetingMinutes()]) }}
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/scss-utils.scss';

.opc-zsched__basic-related-tip {
  font-size: 14px;
  font-weight: 450;
  line-height: 16.8px;
  color: #666487;
  margin-top: 12px;
  @include darkTextColor2;
}
</style>
